import { Col, Form, Input, Row, List } from "antd"
import { useEffect, useState } from "react"
import "./Modal.css"

const ContentModal = (props) => {
  const { tipo, item, tablas } = props
  const [tablasDiccionario, setTablasDiccionario] = useState([])
  const [opcionesCampos, setOpcionesCampos] = useState([])

  useEffect(() => {

    if (tablas) {
      setTablasDiccionario(tablas.tablasDiccionario ? tablas.tablasDiccionario : null)
    }
    try {
      setOpcionesCampos(item.campoDiccionario.opciones.length > 0 ? item.campoDiccionario.opciones : null)
    } catch (error) {
      
    }
  }, [tablas, item])



  if (tipo === 0) {

    return (

      <Row gutter={16}>

        <Col xs={item.campoDiccionario ? 12 : 24} key={item.id}>

          <Col xs={24}>
            <h2
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'stretch',
                flexDirection: 'column',
                padding: '5px',
                marginRight: '30px',
                marginLeft: '30px',
              }}

            >Documento</h2>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label='Nombre' key={item.id}>
              <Input defaultValue={item.nombre} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label="Tipo Campo" key={item.id}>
              <Input defaultValue={item.tipoDeCampo.nombre} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label="Tipo Entrada" key={item.id}>
              <Input defaultValue={item.tipoDeEntrada.nombre} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label="Longitud" key={item.id}>
              <Input defaultValue={item.longitud === 0 ? "Ilimitado" : item.longitud} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label="Formato Entrada" key={item.id}>
              <Input defaultValue={item.formatoDeEntrada.nombre} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label="Caracter Relleno" key={item.id}>
              <Input defaultValue={item.caracterDeRelleno} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label="Descripción" key={item.id}>
              <Input defaultValue={item.descripcion} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label="Texto por Defecto" key={item.id}>
              <Input defaultValue={item.textoPorDefecto} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col hidden={item.opciones !== null ? false : true} xs={24} sm={24}>
            <Form.Item className="col-campos" label="Opciones" key={item.id}>
              {item.opciones && item.opciones.map((item, index) => {
                return (
                  <Form.Item key={index} >
                    <Input defaultValue={item.opcion} autoComplete='off' disabled={true} />
                  </Form.Item>
                )
              })}
            </Form.Item>
          </Col>
        </Col>

        {item.campoDiccionario && (
          <Col hidden={item.campoDiccionario !== null ? false : true} xs={12} key={item.campoDiccionario.id}>

            <Col xs={24}>
              <h2
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'stretch',
                  flexDirection: 'column',
                  padding: '5px',
                  marginRight: '30px',
                  marginLeft: '30px',
                }}
              >
                Diccionario
              </h2>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item className="col-campos" label='Nombre' key={item.campoDiccionario.id}>
                <Input defaultValue={item.campoDiccionario.nombre} autoComplete='off' disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item className="col-campos" label="Tipo Campo" key={item.campoDiccionario.id}>
                <Input defaultValue={item.campoDiccionario.tipoDeCampo.nombre} autoComplete='off' disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item className="col-campos" label="Tipo Entrada" key={item.campoDiccionario.id}>
                <Input defaultValue={item.campoDiccionario.tipoDeEntrada.nombre} autoComplete='off' disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item className="col-campos" label="Longitud" key={item.campoDiccionario.id}>
                <Input defaultValue={item.campoDiccionario.longitud === 0 ? "Ilimitado" : item.campoDiccionario.longitud} autoComplete='off' disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item className="col-campos" label="Formato Entrada" key={item.campoDiccionario.id}>
                <Input defaultValue={item.campoDiccionario.formatoDeEntrada.nombre} autoComplete='off' disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item className="col-campos" label="Caracter Relleno" key={item.campoDiccionario.id}>
                <Input defaultValue={item.campoDiccionario.caracterDeRelleno} autoComplete='off' disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item className="col-campos" label="Descripción" key={item.campoDiccionario.id}>
                <Input defaultValue={item.campoDiccionario.descripcion} autoComplete='off' disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item className="col-campos" label="Texto por Defecto" key={item.campoDiccionario.id}>
                <Input defaultValue={item.campoDiccionario.textoPorDefecto} autoComplete='off' disabled={true} />
              </Form.Item>
            </Col>

            <Col hidden={item.campoDiccionario.opciones.length > 0 ? false : true} xs={24} sm={24}>
              <Form.Item className="col-campos" label="Opciones" key={item.campoDiccionario.id}>
                {opcionesCampos && opcionesCampos.map((item, index) => {
                  return (
                    <Form.Item key={index} >
                      <Input defaultValue={item.opcion} autoComplete='off' disabled={true} />
                    </Form.Item>
                  )
                })}
              </Form.Item>
            </Col>

          </Col>
        )
        }

      </Row >
    )
  }


  if (tipo === 1) {
    return (
      <Row gutter={16}>

        <Col xs={tablasDiccionario ? 12 : 24}>

          <Col xs={24}>
            <h2
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'stretch',
                flexDirection: 'column',
                padding: '5px',
                marginRight: '30px',
                marginLeft: '30px',
              }}

            >Documento</h2>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label='Nombre Tabla' key={tablas.id}>
              <Input defaultValue={tablas.nombreTabla} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label='Descripcion' key={tablas.id}>
              <Input defaultValue={tablas.descripcion} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>
            <Form.Item className="col-campos" label='Filas' key={tablas.id}>
              <Input defaultValue={tablas.cantidadFilas} autoComplete='off' disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}>

          </Col>

          <Col xs={24} sm={24}
            style={{
              marginLeft: '8%',
              marginRight: '8%',
            }}
          >
            <List
              size="small"
              header={<div>Columnas</div>}
              bordered
              dataSource={tablas.columnas}
              renderItem={(item, index) => (
                <List.Item >
                  <Row gutter={16}>
                    {item.nombreColumna}
                  </Row>
                </List.Item>
              )}
            />
          </Col>

        </Col>

        {
          tablasDiccionario && (
            <Col hidden={tablasDiccionario !== null ? false : true} xs={12}>
              <Col xs={24}>
                <h2
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'stretch',
                    flexDirection: 'column',
                    padding: '5px',
                    marginRight: '30px',
                    marginLeft: '30px',
                  }}
                >
                  Diccionario
                </h2>
              </Col>

              <Col xs={24} sm={24}>
                <Form.Item className="col-campos" label='Nombre Tabla' key={tablasDiccionario.id}>
                  <Input defaultValue={tablasDiccionario.nombreTabla} autoComplete='off' disabled={true} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24}>
                <Form.Item className="col-campos" label='Descripcion' key={tablasDiccionario.id}>
                  <Input defaultValue={tablasDiccionario.descripcion} autoComplete='off' disabled={true} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24}>
                <Form.Item className="col-campos" label='Filas' key={tablasDiccionario.id}>
                  <Input defaultValue={tablasDiccionario.cantidadFilas} autoComplete='off' disabled={true} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24}>

              </Col>

              <Col xs={24} sm={24}
                style={{
                  marginLeft: '8%',
                  marginRight: '8%',
                }}
              >
                <List
                  size="small"
                  header={<div>Columnas</div>}
                  bordered
                  dataSource={tablasDiccionario.columnas}
                  renderItem={(item, index) => (
                    <List.Item >
                      <Row gutter={16}>
                        {item.nombreColumna}
                      </Row>
                    </List.Item>
                  )}
                />
              </Col>

            </Col>
          )}

      </Row>
    )
  }

}

export default ContentModal 